export const BASE_CLASS = 'mt-LeadContactButtons'

export const CLASS_LEAD_CONTACT_BUTTONS_WRAPPER = BASE_CLASS
export const CLASS_LEAD_CONTACT_BUTTONS_STICKY = `is-sticky`
export const CLASS_LEAD_CONTACT_BUTTONS_ONLY_STICKY = `${BASE_CLASS}--onlySticky`
export const CLASS_LEAD_CONTACT_BUTTONS_INNER = `${BASE_CLASS}-inner`

export const SELECTOR_STICKY_BUTTONS_WRAPPER = `.${CLASS_LEAD_CONTACT_BUTTONS_WRAPPER}`
export const SELECTOR_STICKY_BUTTONS = `.${CLASS_LEAD_CONTACT_BUTTONS_INNER}`
export const SELECTOR_SMARTBANNER_CONTENT = '.sui-AdSmartbanner'
export const SELECTOR_APPSFLYER_SMARTBANNER_CONTENT = '.responsive-wrapper'

export const DRAWER_CONTENT_TYPE = {
  RESERVATION_INFO: 'reservationInfo',
  RESERVATION_TERMS: 'reservationTerms',
  RESERVATION_LEGAL_CONDITIONS: 'reservationLegalConditions'
}

export const RESERVATION_EVENTS_TRACKING = {
  RESERVATION_INFORMATION_CLICKED: 'Reservation Information Clicked',
  RESERVATION_MORE_INFORMATION_CLICKED: 'Reservation More Information Clicked'
}
